import { LineTagType } from '@/components/LineItem/LineItem'
import { Lease } from '@/types/Homes'

type LeaseFields = keyof Lease

export const leaseMapData: { field: LeaseFields; label: string; tag?: LineTagType }[] = [
  { label: 'Active', field: 'active', tag: 'info' },
  { label: 'Type', field: 'leaseType', tag: 'info' },
  { label: 'Start', field: 'startsOn' },
  { label: 'End', field: 'endsOn' },
  { label: 'Renewal Status', field: 'renewalStatus' },
]
